import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';

const StudentGrades = () => {
  const routes = all_routes;
  const [selectedTerm, setSelectedTerm] = useState('current');

  // Mock data
  const mockGrades = [
    { id: 1, subject: 'Mathematics', grade: 'A', percentage: 92, exam: 'Mid-term', date: '2024-07-15' },
    { id: 2, subject: 'Physics', grade: 'B+', percentage: 87, exam: 'Quiz 1', date: '2024-07-12' },
    { id: 3, subject: 'English', grade: 'A-', percentage: 89, exam: 'Assignment', date: '2024-07-10' },
    { id: 4, subject: 'Chemistry', grade: 'B', percentage: 84, exam: 'Lab Test', date: '2024-07-08' }
  ];

  const studentInfo = {
    name: 'Emily Johnson',
    class: 'Grade 10A',
    rollNo: 'STU001',
    currentGPA: 3.8,
    rank: 12,
    totalStudents: 45
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.parentDashboard}>Parent Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Student Grades</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Student Info */}
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <h5>{studentInfo.name}</h5>
                      <p className="text-muted">{studentInfo.class} • Roll No: {studentInfo.rollNo}</p>
                    </div>
                    <div className="col-md-6">
                      <div className="row text-center">
                        <div className="col-4">
                          <h4 className="text-primary">{studentInfo.currentGPA}</h4>
                          <p className="text-muted mb-0">GPA</p>
                        </div>
                        <div className="col-4">
                          <h4 className="text-success">{studentInfo.rank}</h4>
                          <p className="text-muted mb-0">Rank</p>
                        </div>
                        <div className="col-4">
                          <h4 className="text-info">{studentInfo.totalStudents}</h4>
                          <p className="text-muted mb-0">Total Students</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Grades */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Academic Performance</h4>
                  <button className="btn btn-outline-primary btn-sm">
                    <i className="ti ti-download me-1"></i>Download Report
                  </button>
                </div>

                <div className="card-body border-bottom">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Academic Term</label>
                      <select 
                        className="form-select"
                        value={selectedTerm}
                        onChange={(e) => setSelectedTerm(e.target.value)}
                      >
                        <option value="current">Current Term</option>
                        <option value="previous">Previous Term</option>
                        <option value="yearly">Full Year</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Filter by Subject</label>
                      <select className="form-select">
                        <option>All Subjects</option>
                        <option>Mathematics</option>
                        <option>Physics</option>
                        <option>English</option>
                        <option>Chemistry</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">&nbsp;</label>
                      <button className="btn btn-primary w-100">Apply Filter</button>
                    </div>
                  </div>
                </div>

                <div className="card-body border-bottom">
                  <div className="alert alert-info">
                    <h6><i className="ti ti-info-circle me-2"></i>TODO: Connect to grades API</h6>
                    <ul className="mb-0">
                      <li>Fetch student grades and performance data</li>
                      <li>Generate progress reports and analytics</li>
                      <li>Compare performance with class average</li>
                    </ul>
                  </div>
                </div>

                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Subject</th>
                          <th>Assessment Type</th>
                          <th>Grade</th>
                          <th>Percentage</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockGrades.map((grade) => (
                          <tr key={grade.id}>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="avatar avatar-sm bg-light me-2">
                                  <i className="ti ti-book"></i>
                                </div>
                                {grade.subject}
                              </div>
                            </td>
                            <td>{grade.exam}</td>
                            <td>
                              <span className={`badge ${
                                grade.grade.startsWith('A') ? 'badge-soft-success' :
                                grade.grade.startsWith('B') ? 'badge-soft-primary' :
                                'badge-soft-warning'
                              }`}>
                                {grade.grade}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="progress me-2" style={{width: '60px', height: '6px'}}>
                                  <div 
                                    className="progress-bar bg-success" 
                                    style={{width: `${grade.percentage}%`}}
                                  ></div>
                                </div>
                                {grade.percentage}%
                              </div>
                            </td>
                            <td>{grade.date}</td>
                            <td>
                              <button className="btn btn-sm btn-outline-primary">
                                <i className="ti ti-eye"></i> Details
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentGrades;
